export default __webpack_public_path__ + "static/media/jacket.2d9ba8cf.png";